import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { ThemeProvider } from '@material-ui/styles';
import { CssBaseline } from '@material-ui/core';

import { buildTheme } from '../themes';
import App from './App';

// Reads the persisted theme mode from Redux and rebuilds the MUI theme on
// change, so every `makeStyles` consumer re-renders when the user toggles
// light/dark from the Header.
export default function ThemedApp() {
  const mode = useSelector((state) => state.app.themeMode) || 'light';
  const theme = useMemo(() => buildTheme(mode), [mode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  );
}
